// URL TO DOWNLOAD
export const APP_STORE_URL =
  "https://apps.apple.com/us/app/wheel-of-fortune-show-puzzles/id898040123";
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.scopely.wheeloffortune&hl=en_US&gl=US";

// URL LINKS
export const FACEBOOK_URL = "https://www.facebook.com/TheWheelofFortuneGame/";
export const WHEEL_FORTUNE_URL = "https://www.wheeloffortune.com/";

// URL EXTERNAL
export const PRIVACY_POLICY_URL = "https://scopely.com/privacy";
export const TERMS_SERVICES_URL = "https://scopely.com/tos";
export const HELP_CENTER_URL = "https://scopely.helpshift.com/hc/en/12-wheel-of-fortune/";

// QUERY PARAMS
export const PIGGYBANK_USE_DIRECTPAYMENT = "piggybank_use_directpayment"; // show payment modal on page load for piggy bank
export const SHOW_PRIZE_WHEEL = "showPrizeWheel"; // show prize wheel modal on page load
export const SCROLL_TO = "scrollTo"; // scroll to store section
export const DIRECT_PAYMENT_LISTING = "directPaymentListing" // show payment modal on page load for given store listing
